// --- smooth scroll --------------
 
// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});
 
lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});
 
gsap.ticker.lagSmoothing(0);
 
// --- smooth scroll --------------



document.addEventListener("DOMContentLoaded", function () {
  const menuBtn = document.querySelector(".mobile li p");
  const popup = document.querySelector(".menupopup");
  const closeBtn = document.querySelector(".menupopup_close");
  const wrapper = document.querySelector(".menupopup_wrapper");

  // open / toggle menu
  menuBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    popup.classList.toggle("active");
  });

  // close on close icon click
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      popup.classList.remove("active");
    });
  }

  // close when clicking outside wrapper
  popup.addEventListener("click", function () {
    popup.classList.remove("active");
  });

  // prevent closing when clicking inside content
  wrapper.addEventListener("click", function (e) {
    e.stopPropagation();
  });
});



// ---------- MOUSE SCROLL-X ----------

function enableLeftClickDragScroll(container) {
    if (!container)
        return;
    let isDragging = !1
      , dragStarted = !1
      , startX = 0
      , scrollStart = 0;
    const dragThreshold = 5;
    container.addEventListener("mousedown", e => {
        e.button === 0 && (isDragging = !0,
        dragStarted = !1,
        startX = e.pageX,
        scrollStart = container.scrollLeft,
        container.classList.add("is-dragging"),
        e.preventDefault())
    }
    ),
    container.addEventListener("mousemove", e => {
        if (!isDragging)
            return;
        const deltaX = e.pageX - startX;
        !dragStarted && Math.abs(deltaX) > dragThreshold && (dragStarted = !0),
        dragStarted && (container.scrollLeft = scrollStart - deltaX)
    }
    ),
    container.addEventListener("mouseup", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("mouseleave", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("click", e => {
        dragStarted && (e.preventDefault(),
        e.stopPropagation(),
        dragStarted = !1)
    }
    ),
    container.classList.add("is-draggable")
}
function waitForElementAndInit(selector) {
    document.querySelectorAll(selector).forEach(el => {
        el._dragInitialized || (enableLeftClickDragScroll(el),
        el._dragInitialized = !0)
    }
    ),
    new MutationObserver(mutations => {
        for (const mutation of mutations)
            mutation.addedNodes.forEach(node => {
                node instanceof HTMLElement && (node.matches(selector) && !node._dragInitialized && (enableLeftClickDragScroll(node),
                node._dragInitialized = !0),
                node.querySelectorAll?.(selector)?.forEach(el => {
                    el._dragInitialized || (enableLeftClickDragScroll(el),
                    el._dragInitialized = !0)
                }
                ))
            }
            )
    }
    ).observe(document.body, {
        childList: !0,
        subtree: !0
    })
}
document.addEventListener("DOMContentLoaded", () => {
    [".pdp2-vid-main",".pdp2-review-main",".ingredients-list"].forEach(selector => {
        waitForElementAndInit(selector)
    }
    )
}
);

// ---------- MOUSE SCROLL-X ----------





// ---for cart footer slider ---
function initDeoolSlider() {
  const sliders = document.querySelectorAll(".myDeoolSlider");

  sliders.forEach((slider) => {

    // Destroy existing instance (if already initialized)
    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 800,
    });

  });
}

// When cart drawer opens
document.addEventListener('click', function(e) {
  if (e.target.closest('cart-drawer, .drawer')) {
    setTimeout(() => {
      initDeoolSlider();
    }, 400);
  }
});

// Backup triggers
document.addEventListener("DOMContentLoaded", initDeoolSlider);
document.addEventListener("shopify:section:load", initDeoolSlider);

// ---for cart footer slider ---



  document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.vid-span video');

    const overlay = document.createElement('div');
    overlay.classList.add('video-overlay');
    overlay.innerHTML = `
    <span class="video-close">&times;</span>
    <video controls autoplay></video>
  `;
    document.body.appendChild(overlay);

    const overlayVideo = overlay.querySelector('video');
    const closeBtn = overlay.querySelector('.video-close');

    videos.forEach((video) => {
      video.addEventListener('click', function () {
        const src = this.querySelector('source').src;
        overlayVideo.src = src;
        overlay.classList.add('active');
      });
    });

    function closeVideo() {
      overlay.classList.remove('active');
      overlayVideo.pause();
      overlayVideo.src = '';
    }

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeVideo();
    });

    overlay.addEventListener('click', closeVideo);

    overlayVideo.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });